<template>
  <router-view />
</template>

<script>
export default {
  name: 'LeadsIndex'
}
</script>
